import React, {memo} from 'react';
import styles from './StarRating.module.scss';

const STAR_COUNT = 5;
const STARS = '★'.repeat(STAR_COUNT);

interface StarRatingProps {
    /** Score out of 5; fractions are shown (4.8 fills 96%). */
    rating: number;
    /** Filled-star colour, when not the default yellow. */
    color?: string;
    /** Size overrides (font-size sets the star size). */
    className?: string;
}

/**
 * Five stars with a fractional overlay clipped to the score, so 4.8 reads as 4.8
 * rather than a rounded-up five. Decorative — the score itself is rendered as text
 * beside it, so the stars are hidden from screen readers.
 */
const StarRating = ({rating, color, className}: StarRatingProps) => (
    <span className={className ? `${styles.wrap} ${className}` : styles.wrap} aria-hidden="true">
        <span className={styles.empty}>{STARS}</span>
        {/* Width (and the optional colour) depend on the props, so they stay inline. */}
        <span className={styles.filled} style={{width: `${(rating / STAR_COUNT) * 100}%`, ...(color ? {color} : {})}}>
            {STARS}
        </span>
    </span>
);

export default memo(StarRating);
